import { useState, useEffect } from "react";
import { projectFirestore } from "../firebase";

/**
 * Consolidated Firestore hook for fetching collection data with real-time updates
 * @param {string} collection - Firestore collection name
 * @param {object} options - Configuration options
 * @param {string} options.orderBy - Field to order results by (default: "createdTime")
 * @param {string} options.orderDirection - Sort direction: "asc" or "desc" (default: "asc")
 * @returns {object} { docs, loading, error }
 */
const useFirestoreCollection = (collection, options = {}) => {
  const { orderBy = "createdTime", orderDirection = "asc" } = options;
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    let query = projectFirestore.collection(collection);

    if (orderBy) {
      query = query.orderBy(orderBy, orderDirection);
    }

    const unsub = query.onSnapshot(
      (snap) => {
        let documents = [];
        snap.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setDocs(documents);
        setLoading(false);
      },
      (err) => {
        console.error(`Error fetching ${collection}:`, err);
        setError(err);
        setLoading(false);
      }
    );

    return () => {
      unsub();
    };
  }, [collection, orderBy, orderDirection]);

  return { docs, loading, error };
};

export default useFirestoreCollection;
